import React from 'react';
import styled from 'astroturf/react';
import SearchIconSvg from 'js/design_system/icons/search.svg';

const IconWrapper = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const SearchIcon = () => (
  <IconWrapper>
    <SearchIconSvg fill="#141413" />
  </IconWrapper>
);

// Combined icon and text in a flex container
export const SearchLabel = styled.div`
  @import 'stylesheets/design_system/breakpoint';

  display: flex;
  align-items: center;
  gap: 8px;

  @include breakpoint(medium, small) {
    display: none;
  }
`;

export const SearchInput = styled.input`
  height: 48px;
  padding: 14px 16px;
  padding-left: 36px; /* Space for the icon */
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var(--stroke-medium, #535366);
  background: var(--background-white, #fff);
  font-size: 16px;
  width: 100%;
  &:focus {
    outline: none;
    border-color: var(--stroke-medium, #535366);
  }
`;

export const SearchSection = styled.div`
  @import 'stylesheets/design_system/breakpoint';

  padding: 16px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  width: 100%;

  // Standalone view (when shown outside of menu)
  .standalone-search-container & {
    padding: 0;
  }

  @include breakpoint(small) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-sm-24, 24px);
  }

  @include breakpoint(medium) {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: var(--spacing-sm-24, 24px);
    align-items: flex-start;
  }
`;

export const SearchButtonContainer = styled.div`
  @import 'stylesheets/design_system/breakpoint';

  display: flex;
  flex-shrink: 0;
  margin-left: var(--spacing-sm-24, 24px);

  @include breakpoint(medium) {
    grid-column: 2;
    grid-row: 1;
    align-self: flex-start;
    margin-top: 0;
    margin-left: 0;
  }

  @include breakpoint(small) {
    width: 100%;
    margin-left: 0;

    button {
      width: 100%;
    }
  }
`;

export const InputWrapper = styled.div`
  @import 'stylesheets/design_system/breakpoint';

  position: relative;
  flex: 1;
  min-width: 180px;

  > div:first-child {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 0;
  }

  @include breakpoint(medium, small) {
    max-width: none;
    width: 100%;
  }
`;

export const StyledDropdown = styled.div`
  @import 'stylesheets/design_system/breakpoint';

  width: 350px;
  flex-shrink: 0;
  flex-grow: 0;

  .ds-dropdown-button {
    height: 48px;
    padding: 8px 16px;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    border: 1px solid var(--stroke-medium, #535366);
    background: var(--background-white, #fff);
  }

  @include breakpoint(medium, small) {
    width: 100%;
  }
`;

export const SearchInputAndDropdownContainer = styled.div`
  @import 'stylesheets/design_system/breakpoint';

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-sm-24, 24px);
  width: 100%;

  @include breakpoint(medium, small) {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-sm-24, 24px);
    grid-column: 1 / 2;
  }
`;
